
interface Estado {
  sigla: string;
  nome: string;
  cidades: string[];
}

// Este é apenas o conjunto inicial de dados de exemplo
export const estadosCidades: Estado[] = [
  {
    sigla: "SP",
    nome: "São Paulo",
    cidades: ["São Paulo", "Campinas", "Santos", "Guarulhos", "Osasco"]
  },
  {
    sigla: "RJ",
    nome: "Rio de Janeiro",
    cidades: ["Rio de Janeiro", "Niterói", "Duque de Caxias", "Nova Iguaçu", "Petrópolis"]
  },
  {
    sigla: "MG",
    nome: "Minas Gerais",
    cidades: ["Belo Horizonte", "Uberlândia", "Contagem", "Juiz de Fora", "Betim"]
  }
];

// Vamos criar uma variável para armazenar os dados completos após o fetch
let dadosCompletos: Estado[] = [...estadosCidades];

// Helper functions que usam os dadosCompletos após o carregamento
export const getAllStates = () => dadosCompletos.map(estado => ({ 
  sigla: estado.sigla, 
  nome: estado.nome 
}));

export const getCitiesByState = (sigla: string) => {
  const estado = dadosCompletos.find(estado => estado.sigla.toLowerCase() === sigla.toLowerCase());
  return estado ? estado.cidades : [];
};

export const getStateName = (sigla: string) => {
  const estado = dadosCompletos.find(estado => estado.sigla.toLowerCase() === sigla.toLowerCase());
  return estado ? estado.nome : '';
};

export const isValidCity = (estado: string, cidade: string) => {
  const estadoData = dadosCompletos.find(e => e.sigla.toLowerCase() === estado.toLowerCase());
  if (!estadoData) return false;
  return estadoData.cidades.some(c => c.toLowerCase() === cidade.toLowerCase());
};

export const fetchFullData = async (): Promise<Estado[]> => {
  try {
    console.log("Fetching data from API...");
    const response = await fetch('https://gist.githubusercontent.com/letanure/3012978/raw/6938daa8ba69bcafa89a8c719690225641e39586/estados-cidades.json');
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log("API Data received:", Object.keys(data.estados).length, "estados");
    
    // Transform the data into our format
    const formattedData = Object.keys(data.estados).map(sigla => ({
      sigla,
      nome: data.estados[sigla].nome,
      cidades: data.estados[sigla].cidades
    }));
    
    console.log("Formatted data:", formattedData.length, "estados");
    
    // Atualizamos os dados completos para uso global
    dadosCompletos = formattedData;
    
    return formattedData;
  } catch (error) {
    console.error('Error fetching estados-cidades data:', error);
    // Return the sample data as fallback
    return dadosCompletos; 
  }
};

// Função para inicializar os dados no carregamento da aplicação
export const initializeData = async (): Promise<void> => {
  try {
    dadosCompletos = await fetchFullData();
    console.log("Dados inicializados com sucesso:", dadosCompletos.length, "estados");
  } catch (error) {
    console.error("Erro ao inicializar dados:", error);
  }
};
